export default function (Component) {
  const _Component = Component
  _Component.__i18n = _Component.__i18n || []
  _Component.__i18n.push({
    "locale": "",
    "resource": {
      "en-US": {
        "product__msrp--label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Retail:"])},
        "reviews__reviews--label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named, plural: _plural } = ctx;return _plural([_normalize(["0 Reviews"]), _normalize(["1 Review"]), _normalize([_interpolate(_named("count")), " Reviews"])])},
        "global__by": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["by"])}
      }
    }
  })
}
